// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1SXON","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2ovYI"};